module.exports = __webpack_public_path__ + "static/media/image_news_m.7486ade9.png";